import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';

const propArray = ['IsDeleted'];

const Comment = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              ...removePropertiesFromObject(oldRecord, propArray),
          }
        : oldRecord;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, propArray),
          }
        : newRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export default Comment;
